<template>
    <div class="search-body">
        <div class="search-top">
            <div class="back-body">
                <div class="back-left">
                    <div class="back-icon" @click="backAgo">
                        <img src="../assets/imgs/back.png" alt="">
                    </div>
                    <div class="search-area">
                        <div class="searh-icon"><img src="../assets/imgs/search-icon.jpg" alt=""></div>
                        <input type="text" v-model="keyword" :placeholder="searchTip">
                    </div>
                    <div class="back-msg" @click="search">{{searchMsg}}</div>
                </div>
                <div class="back-index" @click="backIndex">
                    <img src="../assets/imgs/back-index.png" alt="">
                </div>
            </div>
        </div>
        <!--热门搜索-->
        <div v-if="isSearch" class="search_con">
            <div class="hot-area" >
                <div class="hot-title">{{$t("hotsearch")}}</div>
                <div class="hot-fonts">
                    <div class="hot-item" v-for="(item,index) in hotKeywords" :key="index" @click="changeKeyword(item)">{{item}}</div>
                </div>
            </div>
            <div class="add-area"></div>
            <!--{{$t("searchHistory")}}-->
            <div class="history-area" v-if="historyItem.length>0">
                <div class="history-title">
                    <span>{{$t("searchHistory")}}</span>
                    <img src="../assets/imgs/delete.png" @click="delHistory">
                </div>
                <div class="history-fonts">
                    <div class="history-item" v-for="(item,index) in historyItem" :key="index">{{item}}</div>
                </div>
            </div>
        </div>
        <list type="search" :keyword="str" :cate_id="cate_id"></list>
    </div>
</template>

<script>
import list from "@/components/index/list";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "search",
  components: {
    list,
    pagebottom
  },
  data() {
    return {
      str: "",
      searchTip:"",
      historyItem: [],
      hotKeywords: [],
      keyword: "",
      key: "searchHistory",
      cate_id:this.$route.query.cate_id,
      isSearch: true,
      searchMsg: this.$i18n.messages[`${this.$i18n.locale}`].searchMsg
    };
  },
  mounted: function() {
    this.getHotKeyword();
    this.getHisKeyword();
    this.searchTip = this.$t("searchTip");
    if(parseInt(this.cate_id)>0){
      this.search();
    }
  },
  methods: {
    //返回上一页
    backAgo() {
      this.$router.back(-1);
    },
    changeKeyword(kw) {
      this.keyword = kw;
      this.search();
    },
    getHotKeyword() {
      this.req.hot_keywords().then(res => {
        if (res && res.data) {
          this.hotKeywords = res.data.list;
        }
      });
    },
    getHisKeyword() {
      var his = JSON.parse(localStorage.getItem(this.key));
      if (his) {
        for (var i = 0; i < his.length; i++) {}
      } else {
        his = new Array();
      }
      this.historyItem = his;
    },
    //返回首页
    backIndex() {
      this.go.backIndex();
    },
    delHistory: function() {
      localStorage.removeItem(this.key);
      this.historyItem = [];
    },
    addHistory: function(kw) {
      var his = JSON.parse(localStorage.getItem(this.key));
      if (his) {
        var exists = false;
        for (var i = 0; i < his.length; i++) {
          if (his[i] == kw) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          his.push(kw);
        }
      } else {
        his = new Array();
        his.push(kw);
      }
      this.historyItem = his;
      localStorage.setItem(this.key, JSON.stringify(his));
    },
    search: function() {
      if(this.keyword!=""||this.cate_id!=""){
        this.isSearch = false;
        this.str = this.keyword;
        this.addHistory(this.str);
        console.info(this.str);
      }
    }
  }
};
</script>
<style>
.search_con {
  min-height: 10em;
}
.back-body {
  width: 100%;
  height: 1.12rem;
  background:#ff1f4f;
  box-sizing: border-box;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.back-left {
  display: flex;
  align-items: center;
}
.back-icon {
  width: 0.19rem;
  height: 0.32rem;
}
.back-icon img {
  width: 0.19rem;
  height: 0.32rem;
  display: block;
}
.back-index {
  width: 0.44rem;
  height: 0.42rem;
}
.back-index img {
  width: 0.44rem;
  height: 0.42rem;
  display: block;
}
.back-msg {
  font-size: 0.34rem;
  line-height: 0.34rem;
  color: #ffffff;
  font-weight: 700;
}
.search-area {
  width: 4.4rem;
  height: 0.6rem;
  background: #ffffff;
  border-radius: 0.08rem;
  margin: 0 0.2rem 0 0.4rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.searh-icon {
  width: 0.28rem;
  height: 0.28rem;
}
.searh-icon img {
  width: 0.28rem;
  height: 0.28rem;
  display: block;
}
.search-area input {
  outline: none;
  border: none;
  padding-left: 0.2rem;
  font-size: 0.26rem;
}
.search-body {
  padding-top: 1.12rem;
}
.search-top {
  width: 100%;
  height: auto;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
.hot-title {
  width: 100%;
  height: 1.08rem;
  background: #ffffff;
  border-bottom: 0.02rem solid #f2f2f2;
  box-sizing: border-box;
  padding: 0 0 0 0.4rem;
  font-size: 0.3rem;
  line-height: 1.08rem;
  font-weight: 700;
}
.history-title {
  width: 100%;
  height: 1.08rem;
  background: #ffffff;
  border-bottom: 0.02rem solid #f2f2f2;
  box-sizing: border-box;
  padding: 0 0.4rem 0 0.4rem;
  font-size: 0.3rem;
  line-height: 1.08rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.history-title img {
  width: 0.32rem;
  height: 0.32rem;
}
.hot-fonts,
.history-fonts {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 0.4rem 0.4rem 0;
  display: flex;
  flex-wrap: wrap;
}
.hot-item,
.history-item {
  font-size: 0.22rem;
  line-height: 0.22rem;
  color: #808080;
  border: 0.01rem solid #808080;
  border-radius: 0.6rem;
  padding: 0.14rem 0.38rem;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
}
.add-area {
  width: 100%;
  height: 0.16rem;
  background: #f2f2f2;
}
</style>


// WEBPACK FOOTER //
// src/components/search.vue